import { render, staticRenderFns } from "./BuildingServiceImport.vue?vue&type=template&id=038fbd44&"
import script from "./BuildingServiceImport.vue?vue&type=script&lang=ts&"
export * from "./BuildingServiceImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038fbd44')) {
      api.createRecord('038fbd44', component.options)
    } else {
      api.reload('038fbd44', component.options)
    }
    module.hot.accept("./BuildingServiceImport.vue?vue&type=template&id=038fbd44&", function () {
      api.rerender('038fbd44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingServiceImport.vue"
export default component.exports